/** `W-40c`·`W-40d` 가 함께 쓰는 **못 만든 장 블록**. 그리는 것은 `@makit/shared` 의
 * `exportDeclineBlock`(화면) · `exportConfirmBlock`(모달)이 돌려준 값 하나다.
 *
 * ⛔ **이 파일은 글자를 고르지 않는다.** 머리 · 모노 · 금액 라벨 · 링크 라벨 · 설명이 전부
 * 값에 들어 있다. 링크가 설지(`row.link`), 머리에 모노가 설지(`block.trailing`)도 shared 가
 * 정한다 — 화면이 `pages.length === 1` 같은 조건을 다시 세면 판정이 두 벌이 된다.
 *
 * ⛔ **행을 접지 않는다.** 접힌 장은 셀러가 보지 못한 채 결판난다(`7.6.14b` ⓒ). */

import type { ExportDeclineBlock } from "@makit/shared";

export interface DeclineBlockProps {
  block: ExportDeclineBlock;
  /** `그 장 다시 만들기 ›` 를 눌렀다. **문이지 동작이 아니다** — 이 화면이 만드는 일을
   *  시작하지 않는다. 링크가 없는 값(모달 · 내보낸 뒤)에서는 불리지 않는다. */
  onOpenRemake?: (imageId: string) => void;
}

export function DeclineBlock({ block, onOpenRemake }: DeclineBlockProps) {
  return (
    <div className="setgrp decline-block">
      <div className="toggle">
        <span className="head">{block.head}</span>
        {block.trailing ? <span className="mono">{block.trailing.mono}</span> : null}
      </div>
      {block.rows.map((row) => (
        <div key={row.imageId}>
          {row.mono ? <span className="row-name mono">{row.mono}</span> : null}
          <span className="setlink">
            <span>{row.amount.label}</span>
            <span className="v mono">{row.amount.value}</span>
          </span>
          {/* ⭐ 꺾쇠는 갈 곳이 있을 때만 붙인다(`7.5.4`). 갈 곳이 없으면 shared 가 `null` 을
              준다. 웹의 갈 곳은 `W-21`(올리는 중)의 다시 만들기 자리다(`7.7.5a`). */}
          {row.link && onOpenRemake ? (
            <button
              type="button"
              className="setlink clickable"
              onClick={() => onOpenRemake(row.imageId)}
            >
              <span>{row.link}</span>
              <span className="chev" aria-hidden="true">
                ›
              </span>
            </button>
          ) : null}
        </div>
      ))}
      <p className="note prose">{block.note}</p>
    </div>
  );
}
